import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	inject,
	Input,
	Output,
	signal,
} from '@angular/core';
import { DirectionOfFeeType } from '@models/businessSettings/directionOfFees';
import { RecursiveKeyOf } from '@globalUtils/types/recursive-types';
import { BusinessSettings } from '@models/businessSettings/settings';
import { BusinessDispatch } from '@state/business';
import { TestHooks } from './direction-of-fee-dropdown.hooks';

@Component({
	selector: 'app-direction-of-fee-dropdown',
	templateUrl: './direction-of-fee-dropdown.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class DirectionOfFeeDropdownComponent {
	testHooks = TestHooks;
	@Input() public fieldToUpdate: RecursiveKeyOf<BusinessSettings>;
	@Input() set currentDirectionOfFee(
		currentDirectionOfFee: DirectionOfFeeType,
	) {
		this.directionOfFeeSignal.set(currentDirectionOfFee);
	}
	@Input() public label: string;
	@Input() public intercomAttr: string;
	@Input() public disabled = false;
	@Output() public directionOfFeeChange =
		new EventEmitter<DirectionOfFeeType>();

	directionOfFeeTypeOptions = [
		{
			label: 'Trust Ledger',
			value: DirectionOfFeeType.TRUST_LEDGER,
		},
		{
			label: 'Statement of Account',
			value: DirectionOfFeeType.SOA,
		},
		{
			label: "Don't Display",
			value: DirectionOfFeeType.NONE,
		},
	];

	public directionOfFeeSignal = signal<DirectionOfFeeType>(null);

	private businessDispatch = inject(BusinessDispatch);

	setDirectionOfFee(directionOfFeeType: DirectionOfFeeType): void {
		this.directionOfFeeChange.emit(directionOfFeeType);
		this.businessDispatch.OverwriteBusinessFields(
			`defaultSettings.${this.fieldToUpdate}`,
			directionOfFeeType,
		);
	}
}
